export const SHIPPING_DOCUMENT_RESOLUTION = {
  EXISTS: 'exists',
  MISSING: 'missing',
  PROCESSING: 'processing',
  FAILED: 'failed',
  NOT_REQUIRED: 'not_required',
} as const

export const SHIPPING_DOCUMENT_RESOLUTION_MAP = {
  [SHIPPING_DOCUMENT_RESOLUTION.EXISTS]: '存在',
  [SHIPPING_DOCUMENT_RESOLUTION.MISSING]: '缺少',
  [SHIPPING_DOCUMENT_RESOLUTION.PROCESSING]: '產生中',
  [SHIPPING_DOCUMENT_RESOLUTION.FAILED]: '缺少',
  [SHIPPING_DOCUMENT_RESOLUTION.NOT_REQUIRED]: '不需檢查',
} as const

export const SHIPPING_DOCUMENT_OUTCOME = {
  ACCEPTED: 'accepted',
  GENERATED: 'generated',
  FAILED: 'failed',
  EXISTS: 'exists',
  NOT_REQUIRED: 'not_required',
} as const
